import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import { ConfigProvider, Input } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import enUS from 'antd/es/locale/en_US';
import i18n from '@/i18n'; // 导入i18n配置
import $ from 'jquery';
import moment from 'moment';
import { RouterConfig, BrowserRouter, RouterUtil, DataTable, OSS } from '@cyber-ccx/lib';
import pageRoutes from '@/pages';
import 'antd/dist/antd.css';
import '@/index.less';
import 'moment/locale/zh-cn';
import 'moment/locale/en-gb';
import Theme from '@/theme';
import '@/api';
import models from './models';
import Layout from './pages/main/Layout';
import { Redirect } from 'react-router-dom';
DataTable.defaultProps = { ...DataTable.defaultProps, noTools: true, defaultTableSize: 'middle' };

// OSS.init({
//   region: '',
//   accessKeyId: '',
//   accessKeySecret: '',
//   bucket: ''
// })

const validateMessages = {
  required: i18n.t('src-index-1992f2b6e5942f338-1'),
  types: {
    number: i18n.t('src-index-1992f2b6e5942f338-2'),
    integer: i18n.t('src-index-1992f2b6e5942f338-3'),
    float: i18n.t('src-index-1992f2b6e5942f338-4'),
    email: i18n.t('src-index-1992f2b6e5942f338-5'),
  },
};
(window as any).RouterUtil = RouterUtil;
const App: React.FC<any> = () => {
  const [antdLocale, setAntdLocale] = useState(zhCN);

  useEffect(() => {
    Theme.initTheme();

    (window as any)._AMapSecurityConfig = {
      securityJsCode: '18a788251c62ccace0586a2ea6c393f9',
    };

    // 监听语言变化，动态设置antd语言包
    const handleLanguageChange = () => {
      const currentLanguage = i18n.language;
      if (currentLanguage === 'en-US') {
        setAntdLocale(enUS);
        moment.locale('en-gb');
      } else {
        setAntdLocale(zhCN);
        moment.locale('zh-cn');
      }
    };

    // 初始设置
    handleLanguageChange();

    // 监听语言变化事件
    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  return (
    <BrowserRouter>
      <ConfigProvider locale={antdLocale} form={{ validateMessages }}>
        <RouterConfig
          key={'rootConfig'}
          routerJson={pageRoutes}
          onBeforeRouterRender={(router) => {
            if (router.needLogin) {
              if (!models.global.user?.loginToken) {
                return false;
              }
              if (router.routerUrl.startsWith('/main') && router.routerUrl !== '/main' && router.routerUrl !== '/main/error' && !models.global.menus.find((v) => v.url === router.routerUrl)) {
                return <Redirect to={'/main/error'} />;
              }
              return true;
            } else {
              return true;
            }
          }}
          root={'/login'}
        />
      </ConfigProvider>
    </BrowserRouter>
  );
};

$(() => {
  ReactDOM.render(<App />, document.getElementById('root'));
});

serviceWorker.unregister();
